/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type GettingStartedSlaEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const gettingStartedSlaEntryPoint: EntryPoint<
	GettingStartedSlaEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<GettingStartedSlaEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-getting-started-sla", jiraSpaEntry: "async-servicedesk-getting-started-sla" */ './SlaPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
